import React from "react";
import { FONT_0_75, HEADING_FONT } from "../../common/styles/fonts";
import {
    BLACK, WHITE, GRAY_400, GRAY_500,
} from "../../common/styles/colors";

// The Location Icon will render a location icon with no hole
// or it will render a filled location icon with the text in white if passed in
export default ({
    height, width, className, text,
    disabled,
}: {
    height?: number; width?: number; className?: string; text?: string,
    disabled?: boolean;
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="-1 -1 22 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
    >
        <path
            stroke={BLACK}
            d="M9.625 24.7551C7.88828 23.2737 6.27851 21.6497 4.8125 19.9C2.6125 17.2724 1.21504e-06 13.3591 1.21504e-06 9.6301C-0.00194876 5.73548 2.34334 2.22352 5.94147 0.733026C9.5396 -0.757464 13.6813 0.0673099 16.434 2.82248C18.2441 4.62457 19.2581 7.07589 19.25 9.6301C19.25 13.3591 16.6375 17.2724 14.4375 19.9C12.9715 21.6497 11.3617 23.2737 9.625 24.7551Z"
            fill={`url(#${disabled ? "linear_disabled" : "linear_enabled"})`}
        />
        <defs>
            <linearGradient id={disabled ? "linear_disabled" : "linear_enabled"} x1="9.62505" y1="-2.49406e-07" x2="9.62505" y2="24.7551" gradientUnits="userSpaceOnUse">
                <stop stopColor={disabled ? GRAY_500 : "#BE5A61"} />
                <stop offset="1" stopColor={disabled ? GRAY_400 : "#E48E62"} />
            </linearGradient>
        </defs>
        {text && (
            <text
                className="text"
                x="5.5"
                y="14.5"
                fill={WHITE}
                fontFamily={HEADING_FONT}
                fontWeight="bold"
                fontSize={FONT_0_75}
            >
                {text}
            </text>
        )}
    </svg>
);
